import { Component, Input, signal } from '@angular/core';
import { MatchedProfile } from '../../../shared/entities/Search/MatchedProfile';
import { Profile } from '../../../shared/entities/Profile/Profile';

@Component({
  selector: 'app-profile-master-details',
  templateUrl: './profile-master-details.component.html',
  styleUrl: './profile-master-details.component.scss'
})
export class ProfileMasterDetailsComponent {


  profileList = signal<MatchedProfile[] | undefined>(undefined);
  selectedProfile = signal<MatchedProfile | undefined>(undefined);
  selectedProfileInfo = signal<Profile | undefined>(undefined);

  @Input({ required: true })
  set profiles(match: MatchedProfile[] | undefined) {
    this.profileList.set(match);
    this.selectedProfile.set(undefined);
    this.selectedProfileInfo.set(undefined);  
  }

  select(profile: MatchedProfile) {
    this.selectedProfile.set(profile);
    this.selectedProfileInfo.set(profile?.profile ?? undefined)
  }

  isSelected(expert: MatchedProfile): boolean {
    if (this.selectedProfile() === undefined) {
      return false;
    }

    if (expert.profile.ceRMitId === undefined) {
      return false;
    }

    return expert.profile.ceRMitId === this.selectedProfile()?.profile.ceRMitId;
  }
}
